import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';

type Service = 'host' | 'quality';

@Injectable({providedIn: 'root'})
export class Api {

  constructor(private http: HttpClient) {}

  get(endpoint: string, service: Service = 'host'): Observable<any> {
    return this.http.get(`${environment.api[service]}/${endpoint}`);
  }

  getPage(endpoint: string, params: any = {}, service: Service = 'host'): Observable<any> {
    return this.http.get(`${environment.api[service]}/${endpoint}`, {params});
  }

  post(endpoint: string, payload: any, service: Service = 'host'): Observable<any> {
    return this.http.post(`${environment.api[service]}/${endpoint}`, payload);
  }

  put(endpoint: string, id?: string | null, payload?: any, service: Service = 'host'): Observable<any> {
    const url = id ? `${environment.api[service]}/${endpoint}/${id}` : `${environment.api[service]}/${endpoint}`;
    return this.http.put(url, payload);
  }

  patch(endpoint: string, id?: string | null, payload?:any, service: Service = 'host'):Observable<any>{
    const url = id ? `${environment.api[service]}/${endpoint}/${id}` : `${environment.api[service]}/${endpoint}`;
    return this.http.patch(url, payload);
  }

  delete(endpoint: string, id: string, service: Service = 'host'): Observable<any> {
    return this.http.delete(`${environment.api[service]}/${endpoint}/${id}`);
  }

  bulkDelete(endpoint: string, payload?: any, service: Service = 'host'): Observable<any> {
    return this.http.delete(`${environment.api[service]}/${endpoint}`, payload);
  }
}
